<template>
	<v-dialog
    v-model="dialog"
    width="400"
    content-class="deleteConfirmBtn"
  >
  	<template v-slot:activator="{ on, attrs }">
      <v-btn
        :color="color"
        :icon="icon"
        :class="btnClass"
        v-bind="attrs"
        v-on="on"
      >
        <slot></slot>
      </v-btn>
    </template>
    <v-card class="text-center pa-8">
    	<v-icon color="red">far fa-times-circle</v-icon>
    	<div class="my-6">該操作不可復原</div>
    	<div class="d-flex justify-center">
    		<v-btn class="mx-4" @click="dialog = false">取消</v-btn>
    		<v-btn class="mx-4 red white--text" @click="$emit('delete'); dialog = false">刪除</v-btn>
    	</div>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
	props: ['icon', 'color', 'btnClass'],
	data() {
		return {
			dialog: false
		}
	}
}
</script>

<style lang="scss" scoped>
.deleteConfirmBtn {
	.v-icon {
		font-size: 80px;
	}
	.v-btn {
		width: 130px;
	}
}
</style>